import { Component, OnInit } from '@angular/core';
import { FormContentChatComponent } from '../formcontentchat/formcontentchat.component';
import { MatDialog, MatDialogConfig,MAT_DIALOG_DATA  } from '@angular/material';
import { GlobalService } from '../global.service';
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.sass']
})
export class ChatComponent implements OnInit {
 
  constructor(public dialog:MatDialog,private global:GlobalService) { }
  ngOnInit() {
  }
  chat(){
    if(sessionStorage.getItem("session")!=null){
      this.global.validateSession();
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    const dialogRef =this.dialog.open(FormContentChatComponent, dialogConfig);
  }
}